/* global previews */
import { getLayoutInfo } from "@frontend/group/modules/import-template-from-psd/import-from-psd-new-template";
import LAYOUT_API from "@frontend/services/api/layout";
import { GeneratePreviewImage } from "@frontend/group/generate-preview-image";

const DESIRED_THUMBNAIL_WIDTH = 300;
const DESIRED_THUMBNAIL_HEIGHT = 300;

export async function saveLayoutThumbnail() {
  try {
    const { customerId } = getLayoutInfo();
    const url = new URL(window.location);
    let layoutId = url.pathname.split('/')[url.pathname.split('/').length - 2];
    
    if (window.isBannerBuilder) {
      const params = new URLSearchParams(window.location.search);
      layoutId = params.get('layoutId');
    }
    
    if (window.__EMBED_TOKEN__) {
      layoutId = url.pathname.split('/')[url.pathname.split('/').length - 1]
    }

    const formData = new  FormData();

    if (previews?.[0]) {
      const thumbnailFile = await new GeneratePreviewImage(previews[0])
          .resize(DESIRED_THUMBNAIL_WIDTH, DESIRED_THUMBNAIL_HEIGHT)
          .file(`${Date.now()}.jpg`, 'image/jpg');

      formData.append('thumbnailImg', thumbnailFile);
    } else {
        formData.append('deleteThumbnail', '1');
    }

    await LAYOUT_API.updateLayout(customerId, layoutId, formData);
  } catch(error) {
    console.error('The error occurred in the saveLayoutThumbnail method:', error);
  }
}

export async function isThumbnailExist(instances) {
  const url = new URLSearchParams(window.location.href);

  if (url.has('generateThumbnail')) {
    return false;
  }
  
  if (!instances?.length) {
    return true;
  }

  if (instances[0].grid_layout.thumbnail) {
    const res = await axios.head(`/share?file=${instances[0].grid_layout.thumbnail}`);

    return !!res.headers["content-length"];
  }

  return false;
}

export async function generateThumbnail(customerId, layoutId, redirectUrl) {
  try {
    let { data } = await LAYOUT_API.getPreviews(customerId, layoutId);
    
    if (!data.instances.length) {
      toastr.warning('There are no templates in the layout');
      
      return;
    }
    
    window.location.href = `/banner/${customerId}/group/${layoutId}/show?latest_modified_version=true&generateThumbnail=true&redirectUrl=${redirectUrl}`;
    
  } catch (error) {
    toastr.error('An error occurred while creating the thumbnail.');
  }
}

export function goToThePreviousPage() {
  const url = new URL(window.location.href);
  
  if (url.hash && url.hash.includes('layout-folders')) {
    return window.location.href = url.searchParams.get('redirectUrl') + url.hash;
  }
  
  window.location.href = url.searchParams.get('redirectUrl');
}
